import { maxLength, ValidationField, Validator } from "~/extensions/utils";
export class RoomSelectFindConditionValiator extends Validator {
    constructor(data) {
        const constraints = {
            keyword: {
                length: maxLength(40)
            }
        };
        super(data, constraints);
        this.keyword = new ValidationField("keyword", data, constraints);
    }
    keyword;
}
